import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import {connect} from 'react-redux';
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../../../ui/TextField";
import Checkbox from "../../../../../../../../../ui/Checkbox";
import DataSelect from "../../../../../../../../../ui/DataSelect";

import {loadList as loadRegionList} from "../../../../../../../../../Dict/Region/View/fetch";
import {loadByRegion as loadMunicipalList} from "../../../../../../../../../Dict/Municipal/View/fetch";

const defaultData = {
  firstName: "",
  lastName: "",
  middleName: "",
  email: "",
  phone: "",
  snils: "",
  birthday: "",
  sex: null,
  region: null,
  municipal: null,
  register: false
};

const GENDERS = [ { id: 1, name: "мужской" }, { id: 0, name: "женский" } ];

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  label: {
    fontSize: 12
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  },
  marginTop: {
    marginTop: 13
  }
});

const AddStudentForm = ({ disabled, onFormChange, hideCheckbox, classes,
loadRegionList, loadMunicipalList, regionList, municipalList, initialData }) => {
  const [data, setData] = React.useState(initialData || defaultData);
  const { firstName, lastName, middleName, email, phone,
    snils, birthday, sex, region, municipal, register } = data;

  useEffect(() => {
    loadRegionList();
  }, []);

  useEffect(() => {
    if (region && region > -1){
      loadMunicipalList(region);
    }
  }, [region]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextField
            value={lastName}
            onChange={e => onChange("lastName", e.target.value)}
            label="Фамилия"
            disabled={disabled}
            required
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={firstName}
            onChange={e => onChange("firstName", e.target.value)}
            label="Имя"
            disabled={disabled}
            required
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={middleName}
            onChange={e => onChange("middleName", e.target.value)}
            label="Отчество"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={4}>
          <DataSelect
            value={sex}
            onChange={value => onChange("sex", value.id)}
            label="Пол"
            dataSource={GENDERS}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={birthday}
            onChange={e => onChange("birthday", e.target.value)}
            label="Дата рождения"
            disabled={disabled}
            type="date"
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            mask="999-999-999-99"
            maskChar="_"
            value={snils}
            onChange={e => onChange("snils", e.target.value)}
            label="Снилс"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
        {regionList &&
          <DataSelect
            value={region}
            onChange={value => onChange("region", value.id)}
            label="Регион"
            dataSource={regionList}
          />}
        </Grid>
        <Grid item xs={6}>
        {municipalList &&
          <DataSelect
            value={municipal}
            onChange={value => onChange("municipal", value.id)}
            label="Муниципальное образование"
            dataSource={municipalList}
          />}
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={phone}
            onChange={e => onChange("phone", e.target.value)}
            label="Контактный телефон"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={email}
            onChange={e => onChange("email", e.target.value)}
            label="E-mail"
            disabled={disabled}
            required
          />
        </Grid>
        {!hideCheckbox &&
        <Grid item xs={4}>
          <Checkbox checked={register}
          handleChange={(_, val) => onChange("register", val)}
          label="Отправить приглашение"/>
        </Grid>}
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  regionList: state.dictRegionView.list,
  municipalList: state.dictMunicipalView.list
});

const mapDispatchToProps = dispatch => ({
  loadRegionList: () => dispatch(loadRegionList()),
  loadMunicipalList: id => dispatch(loadMunicipalList(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddStudentForm));
